import Bullet from '../../Entity/Bullet.js'
import Vector from '../../Vector.js'
import Size from '../../Size.js'

export const TYPE_WALL_DESTROYED = 'wall_destroyed'

class WallDestroyed {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        const walls = game.getWalls();
        if(walls.hasId(data.id)) {
            walls.getById(data.id).destroy();
        }
    }
    
}

export default WallDestroyed
